export default __webpack_public_path__ + "static/media/information.811e147c.svg";